"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResultCountIndicator = exports.SearchNoResultsIndicator = exports.SearchLoadingIndicator = exports.SearchListActionButtonIndicator = exports.SearchErrorIndicator = exports.MemoisedLiveRegion = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../button");

var _icons = require("../icons");

var _layout = require("../layout");

var _liveAnnouncer = require("../live-announcer");

var _screenReaderOnly = require("../screen-reader-only");

var _text = require("../text");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ItalicText = ( /*#__PURE__*/0, _styledBase.default)(_text.Text, {
  target: "ezgdc1a0"
})(process.env.NODE_ENV === "production" ? {
  name: "1msjh1x",
  styles: "font-style:italic;"
} : {
  name: "1msjh1x",
  styles: "font-style:italic;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var SearchLoadingIndicator = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var loadingText = _ref.loadingText;
  return (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    justifyContent: "center"
  }, (0, _core.jsx)(ItalicText, {
    fontSize: "T200",
    color: "neutral70"
  }, loadingText));
});
exports.SearchLoadingIndicator = SearchLoadingIndicator;
var SearchNoResultsIndicator = /*#__PURE__*/(0, _react.memo)(function (_ref2) {
  var noResultsText = _ref2.noResultsText;
  return (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    justifyContent: "center"
  }, (0, _core.jsx)(ItalicText, {
    fontSize: "T200",
    color: "neutral70"
  }, noResultsText));
});
exports.SearchNoResultsIndicator = SearchNoResultsIndicator;
var SearchResultCountIndicator = /*#__PURE__*/(0, _react.memo)(function (_ref3) {
  var resultsCount = _ref3.resultsCount;
  return (0, _core.jsx)(_text.Text, {
    fontSize: "T100",
    color: "neutral70"
  }, resultsCount);
});
exports.SearchResultCountIndicator = SearchResultCountIndicator;
var SearchErrorIndicator = /*#__PURE__*/(0, _react.memo)(function (_ref4) {
  var loadingErrorText = _ref4.loadingErrorText;
  return (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    justifyContent: "center",
    gridGap: "S100"
  }, (0, _core.jsx)(_icons.IconAlertCircleFill, {
    "aria-hidden": true,
    color: "red70",
    size: _icons.IconSize.ExtraSmall
  }), (0, _core.jsx)(_text.Text, {
    fontSize: "T200",
    color: "red70"
  }, loadingErrorText));
});
exports.SearchErrorIndicator = SearchErrorIndicator;
var SearchListActionButtonIndicator = /*#__PURE__*/(0, _react.memo)(function (_ref5) {
  var handleListActionButtonClick = _ref5.handleListActionButtonClick,
      handleListActionButtonTab = _ref5.handleListActionButtonTab,
      labelId = _ref5.labelId,
      listActionButtonRef = _ref5.listActionButtonRef,
      listActionButtonText = _ref5.listActionButtonText;
  return (0, _core.jsx)(_button.Button, {
    "aria-describedby": labelId,
    icon: (0, _core.jsx)(_icons.IconChevronRight, {
      "aria-hidden": true,
      size: _icons.IconSize.ExtraSmall
    }),
    iconPosition: _button.ButtonIconPosition.Trailing,
    onClick: handleListActionButtonClick,
    onPointerDown: handleListActionButtonClick,
    onKeyDown: handleListActionButtonTab,
    ref: listActionButtonRef,
    size: _button.ButtonSize.Small,
    variant: _button.ButtonVariant.Tertiary
  }, listActionButtonText);
});
exports.SearchListActionButtonIndicator = SearchListActionButtonIndicator;
var MemoisedLiveRegion = /*#__PURE__*/(0, _react.memo)(function (_ref6) {
  var announcement = _ref6.announcement;
  return (0, _core.jsx)(_liveAnnouncer.LiveRegion, {
    role: _liveAnnouncer.LiveRegionRole.Status,
    "aria-live": "polite"
  }, (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, announcement));
});
exports.MemoisedLiveRegion = MemoisedLiveRegion;